export default __webpack_public_path__ + "static/media/logical-and.77e78f31.svg";